// src/components/Forbidden.js
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Forbidden() {
  const { t } = useTranslation();
  
  return (
    <div className="p-8 text-center">
      <h1 className="text-2xl font-semibold">403 - {t('errors.forbidden_title')}</h1>
      <p className="mt-2 text-gray-600">{t('errors.forbidden_message')}</p>
    </div>
  );
}
